import TablePaginationPlatforms from "../../../../components/TablePaginationPlatforms";
import { translate } from "../../../../utils/Common";

// cantidad de paquetes en cada locker
const PackagesInPlatforms = ({ cantPackagesInLocker }) => {
  const headerRow = (
    <tr>
      <th className="text-right">{translate("dashboard.home.admin_stats.quantity")}</th>
      <th>{translate("dashboard.home.status_platforms.platform")}</th>
    </tr>
  );
  return (
    <TablePaginationPlatforms
      data={cantPackagesInLocker}
      headerRow={headerRow}
      title={translate("dashboard.home.packages_platforms.title")}
      notFound={translate("dashboard.home.packages_platforms.not_found")}
      filterStatus
      isActivePackage
    />
  );
};

export default PackagesInPlatforms;
